
import { StyledWrapModal } from 'components/common/Modal/Modal.styles';
import React, { ChangeEvent, useRef, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { useToggle } from 'react-use';
import { getCdnPath } from 'utils/image';

import { SvgUse } from '@dnse/ui';

import { EnModal } from '@encapital/ui';
import { ApplicationForm } from '../../modules/application/ApplicationForm';
export const UploadYourCV = () => {
  const [isOpenModal, toggleModal] = useToggle(false);
  const [isUploadSuccess, setIsUploadSuccess] = useState(false);
  const [fileUploaded, setFileUploaded] = useState<File | null>(null);
  const fileInputRef = useRef(null);
  const handleClickUploadCVButton = () => {
    fileInputRef.current.click();
  };

  const onFileInputChange = async (e: ChangeEvent<HTMLInputElement>) => {
    setFileUploaded(e.target.files[0]);
    setIsUploadSuccess(false);
    if (e.target.files[0]) {
      toggleModal(true);
    }
    if (e.target) {
      e.target.value = '';
    }
  };

  return (
    <>
      <div
        className="min-[1120px]:w-full min-[1120px]:px-3 min-[1120px]:py-4 rounded min-[1120px]:border border-solid min-[1120px]:border-gray-990"
      >
        <div className="hidden min-[1120px]:block text-sm font-normal mb-3">
          Hãy cứ gửi hồ sơ nhé! DNSE sẽ liên hệ với bạn sớm 🥰
        </div>
        <button
          onClick={handleClickUploadCVButton}
          className="w-full min-[1120px]:h-[38px] flex justify-center gap-x-2 items-center text-brand-300 font-medium text-sm min-[1120px]:text-base min-[1120px]:py-[9px] rounded-[41px] min-[1120px]:border-[1px] min-[1120px]:border:solid border-brand-300"
        >
          <SvgUse id={'upload-outline'} height={16} width={16} /> Tải lên hồ sơ
        </button>
        <input
          type={'file'}
          ref={fileInputRef}
          name={'cv'}
          className={'hidden'}
          accept={'.pdf,.doc,.docx'}
          onChange={e => onFileInputChange(e)}
        />
      </div>

      <EnModal open={isOpenModal} onClose={toggleModal}>
        <StyledWrapModal
          flexDirection="column"
          className="relative"
          width={isMobile ? 343 : 450}
        >
          {
            isUploadSuccess
              ? UploadSuccess(toggleModal)
              : <ApplicationForm
                  file={fileUploaded}
                  callback={() => {
                    setIsUploadSuccess(true);
                  }}
                  toggleModal={toggleModal}
              />
          }
        </StyledWrapModal>
      </EnModal>
    </>
  );
};

const UploadSuccess = (toggleModal: (value: boolean) => void) => {
  return (
    <div className="rounded-lg flex flex-col gap-y-4">
      <div
        className="flex w-16 h-16 p-1 justify-center items-center gap-[16px]"
        style={{
          borderRadius: '100px',
          background: 'rgba(37, 165, 73, 0.15)'
        }}
      >
        <img
          src={getCdnPath('svg/upload-successfully.svg')}
          alt="icon"
          width={48}
          height={48}
        />
      </div>
      <SvgUse
        id="close-outline-2"
        className="absolute top-[24px] right-[24px] w-[24px] h-[24px] cursor-pointer"
        onClick={() => toggleModal(false)}
      />
      <h4 className="text-2xl font-medium">
        Chúc mừng bạn đã gửi hồ sơ ứng tuyển tới DNSE thành công!
      </h4>
      <p className="text-base font-normal leading-6 self-stretch">
        Trong thời gian chờ đợi, bạn có thể tìm hiểu thêm về chúng tôi tại {``}
        <span>
          <a
            href="/happy-dnse/tin-tuc"
            className="font-medium underline text-brand-300"
          >
            Happy DNSE {``}
          </a>
        </span>
        nhé!
      </p>
    </div>
  )
}
